import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import PropTypes from 'prop-types';

import {routeToRedirectEditProject} from '../../../util/uiconstants';
import {labels} from '../../../util/utils';

import {getAllProjects} from '../../../actions/Project/projectAction';
import {setEditMode} from '../../../actions/EditProject/editprojectactions';
import {clearAllAccessGroups} from '../../../actions/AccessGroups/Accessgroupactions';

import {IconoirProhibition} from '@ey-xd/motif-icon';

import ProgressLoader from '../../CoreWrappers/ProgressLoader';
import IconMessage from '../../CoreWrappers/IconMessage';
import StyledProjectList from './StyledProjectList';

const ProjectList = ({projects, url, renderProject, filterCondition, isSearching, emptyMessage}) => {
	const [isLoading, setIsLoading] = useState(true);

	const dispatch = useDispatch();

	useEffect(() => {
		if (url) dispatch(getAllProjects(url)).finally(() => setIsLoading(false));
		else setIsLoading(false);
		dispatch(setEditMode(false, routeToRedirectEditProject.home, null, null));
		dispatch(clearAllAccessGroups());
	}, []);

	const renderEmpty = () => {
		const message = isSearching ? labels.noResultsFound : emptyMessage;

		const props = {
			title: message,
			icon: IconoirProhibition
		};

		return <IconMessage {...props} />;
	};

	const filteredProjects = filterCondition ? projects.filter(filterCondition) : [...projects];

	const isEmpty = !(projects?.length > 0);

	return (
		<>
			{isLoading && <ProgressLoader view="inlineView" />}
			{!isLoading && isEmpty && renderEmpty()}
			{!isLoading && !isEmpty && (
				<StyledProjectList>{!isLoading && filteredProjects.map(renderProject)}</StyledProjectList>
			)}
		</>
	);
};

ProjectList.propTypes = {
	url: PropTypes.string,
	renderProject: PropTypes.func,
	filterCondition: PropTypes.func,
	isSearching: PropTypes.bool,
	emptyMessage: PropTypes.string
};

ProjectList.defaultProps = {
	url: null,
	renderProject: null,
	filterCondition: null,
	isSearching: false,
	emptyMessage: ''
};

export default ProjectList;
